import { Routes } from '@angular/router';
import { StepSelectCompanyComponent } from './pages/onboarding/stepSelectCompany/stepSelectCompany.component';
import { StepDescriptionComponent } from './pages/onboarding/stepDescription/stepDescription.component';
import { StepUserInfoComponent } from './pages/onboarding/step-user-info/step-user-info.component';
import { OnboardingGuard } from './onboarding.guard';

export const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    component: StepSelectCompanyComponent,
  },
  {
    path: 'description',
    component: StepDescriptionComponent,
    canActivate: [OnboardingGuard],
  },
  {
    path: 'insert-info',
    component: StepUserInfoComponent,
    canActivate: [OnboardingGuard],
  },
];
